import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Form, Button, Input, Row, Col, Alert, Checkbox } from 'antd';
import React from 'react';
import './index.css';
import { ViewDocument } from '../../../components';


function MissingWordsQuestion({ dictionary, language, withChecking = false, form, Answers }) {
  if (Answers) {
    form.setFieldsValue({ missingWords: Answers });
  }

  return (
    <React.Fragment>
      <Alert
        message={dictionary?.Attention[language]}
        description={dictionary?.CorrectObjects[language]}
        type="error"
        showIcon
      />
      <Form.List name="missingWords">
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => {
              return (
                <div className="box" key={field.key}>
                  <div className="missingWords">
                    <div className="missingWordsBox">
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Form.Item
                          labelCol={6}
                          label={
                            <span>
                              {dictionary?.MissingWord[language]} {index + 1}
                            </span>
                          }
                          name={[field.name, 'answerText']}
                          fieldKey={[field.fieldKey, 'answerText']}
                          rules={[
                            {
                              required: true,
                              message: `${dictionary?.FillTheMissingWord[language]} ${index + 1}`,
                            },
                          ]}>
                          <Input style={{ width: '20vw' }} />
                        </Form.Item>
                        {Answers && form.getFieldValue('missingWords')[field.fieldKey]?.files > 0 &&
                          <Form.Item label={dictionary?.File[language]}>
                            <ViewDocument files={form.getFieldValue('missingWords')[field.fieldKey]?.files} />
                          </Form.Item>
                        }
                        {!Answers && <Form.Item>
                          <Button
                            style={{ marginLeft: '50px' }}
                            type="primary"
                            shape="round"
                            danger={true}
                            icon={<MinusCircleOutlined />}
                            onClick={() => {
                              remove(field.name);
                            }}>
                            {dictionary?.Delete[language]}
                          </Button>
                        </Form.Item>
                        }
                        {withChecking && (
                          <Form.Item
                            labelCol={5}
                            label={<span>{dictionary?.RightAnswer[language]}</span>}
                            name={[field.name, 'isRight']}
                            fieldKey={[field.fieldKey, 'isRight']}>
                            <Checkbox
                              checked={form.getFieldValue('missingWords')[field.fieldKey]?.isRight}
                              onChange={() => {
                                form.setFieldsValue({
                                  ...form.getFieldsValue(),
                                  missingWords: form
                                    .getFieldsValue()
                                    .missingWords.map((e, index) => {
                                      return index === field.fieldKey
                                        ? { ...e, isRight: !e.isRight }
                                        : e;
                                    }),
                                });
                              }}
                            />
                          </Form.Item>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {!Answers && <Form.Item labelAlign="right">
              <Button
                type="primary"
                shape="round"
                style={{ marginTop: 20, marginLeft: 30 }}
                icon={<PlusOutlined />}
                onClick={() => {
                  add();
                }}>
                {dictionary?.AddMore[language]}
              </Button>
            </Form.Item>
            }
          </>
        )}
      </Form.List>
    </React.Fragment>
  );
}

export default MissingWordsQuestion;
